import { Link, useLocation } from "react-router-dom";
import React from "react";
import { LuChevronRight, LuTickets } from "react-icons/lu";
import { CiLogout, CiLogin, CiUser } from "react-icons/ci";
import { PiCardsBold } from "react-icons/pi";
import { IoMdClose } from "react-icons/io";
import { IoMdAddCircleOutline } from "react-icons/io";
import { MdWorkOutline } from "react-icons/md";

/* eslint-disable react/prop-types */
const MobileMenu = React.forwardRef(
    ({ setIsOpen, isAuthenticated, logout }, ref) => {
        const location = useLocation();

        const itemClass = (path) => {
            const isActive =
                location.pathname === path ||
                (path !== "/" && location.pathname.startsWith(`${path}/`));

            return [
                "group flex items-center justify-between rounded-xl border px-3 py-3.5 text-[15px] font-medium transition",
                isActive
                    ? "border-rose-500/35 bg-gradient-to-r from-rose-500/20 to-zinc-900 text-white"
                    : "border-zinc-800 bg-zinc-900/65 text-zinc-100 hover:border-zinc-700 hover:bg-zinc-800/70",
            ].join(" ");
        };

        const sectionTitleClass =
            "px-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-zinc-500";

        const labelWithIconClass = "flex items-center gap-3";
        const iconWrapClass =
            "inline-flex h-8 w-8 items-center justify-center rounded-lg bg-zinc-800/80 text-zinc-200";
        const chevronClass =
            "text-zinc-500 transition-transform group-hover:translate-x-0.5 group-hover:text-zinc-300";

        const accountLinks = isAuthenticated ? (
            <>
                <Link
                    to="/tickets"
                    className={itemClass("/tickets")}
                    onClick={() => setIsOpen(false)}
                >
                    <span className={labelWithIconClass}>
                        <span className={iconWrapClass}>
                            <LuTickets className="text-base" />
                        </span>
                        Mis Tickets
                    </span>
                    <LuChevronRight className={chevronClass} />
                </Link>
                <Link
                    to="/profile"
                    className={itemClass("/profile")}
                    onClick={() => setIsOpen(false)}
                >
                    <span className={labelWithIconClass}>
                        <span className={iconWrapClass}>
                            <CiUser className="text-lg" />
                        </span>
                        Mis Datos
                    </span>
                    <LuChevronRight className={chevronClass} />
                </Link>
            </>
        ) : (
            <>
                <Link
                    to="/login"
                    className={itemClass("/login")}
                    onClick={() => setIsOpen(false)}
                >
                    <span className={labelWithIconClass}>
                        <span className={iconWrapClass}>
                            <CiLogin className="text-lg" />
                        </span>
                        Iniciar Sesión
                    </span>
                    <LuChevronRight className={chevronClass} />
                </Link>
                <Link
                    to="/register"
                    className={itemClass("/register")}
                    onClick={() => setIsOpen(false)}
                >
                    <span className={labelWithIconClass}>
                        <span className={iconWrapClass}>
                            <CiUser className="text-lg" />
                        </span>
                        Registrarse
                    </span>
                    <LuChevronRight className={chevronClass} />
                </Link>
            </>
        );

        return (
            <div className="fixed inset-0 z-50 bg-black/55 backdrop-blur-[2px]">
                <div
                    ref={ref}
                    className="relative ml-auto flex h-full w-[min(86vw,21rem)] flex-col border-l border-zinc-800 bg-zinc-950/95 p-4 shadow-[0_20px_60px_rgba(0,0,0,0.5)]"
                >
                    <div
                        className="pointer-events-none absolute inset-0 opacity-80"
                        aria-hidden="true"
                        style={{
                            background:
                                "radial-gradient(circle at 15% 0%, rgba(255,74,110,0.18), transparent 36%), radial-gradient(circle at 100% 35%, rgba(59,130,246,0.14), transparent 34%)",
                        }}
                    />

                    <div className="relative mb-6 flex items-center justify-between">
                        <div>
                            <p className="text-xs uppercase tracking-[0.16em] text-zinc-500">
                                Navegación
                            </p>
                            <p className="text-lg font-semibold text-white">Menú</p>
                        </div>
                        <button
                            onClick={() => setIsOpen(false)}
                            className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-zinc-700 bg-zinc-900/80 text-zinc-100 transition hover:bg-zinc-800"
                            aria-label="Cerrar Menu"
                        >
                            <IoMdClose className="text-2xl" />
                        </button>
                    </div>

                    <nav className="relative flex-1 overflow-y-auto">
                        <div className="space-y-6">
                            <div className="space-y-2.5">
                                <p className={sectionTitleClass}>Explorar</p>
                                <Link
                                    to="/"
                                    className={itemClass("/")}
                                    onClick={() => setIsOpen(false)}
                                >
                                    <span className={labelWithIconClass}>
                                        <span className={iconWrapClass}>
                                            <PiCardsBold className="text-base" />
                                        </span>
                                        Eventos
                                    </span>
                                    <LuChevronRight className={chevronClass} />
                                </Link>
                                <Link
                                    to="/producers"
                                    className={itemClass("/producers")}
                                    onClick={() => setIsOpen(false)}
                                >
                                    <span className={labelWithIconClass}>
                                        <span className={iconWrapClass}>
                                            <MdWorkOutline className="text-base" />
                                        </span>
                                        Productoras
                                    </span>
                                    <LuChevronRight className={chevronClass} />
                                </Link>
                                <a
                                    href="https://producer.passevent.site"
                                    className="group flex items-center justify-between rounded-xl border border-zinc-800 bg-zinc-900/65 px-3 py-3.5 text-[15px] font-medium text-zinc-100 transition hover:border-zinc-700 hover:bg-zinc-800/70"
                                    onClick={() => setIsOpen(false)}
                                >
                                    <span className={labelWithIconClass}>
                                        <span className={iconWrapClass}>
                                            <IoMdAddCircleOutline className="text-lg" />
                                        </span>
                                        Crea tu evento
                                    </span>
                                    <LuChevronRight className={chevronClass} />
                                </a>
                            </div>

                            <div className="space-y-2.5">
                                <p className={sectionTitleClass}>Cuenta</p>
                                {accountLinks}
                            </div>
                        </div>
                    </nav>

                    {isAuthenticated && (
                        <div className="relative mt-4 border-t border-zinc-800 pt-4">
                            <button
                                className="group flex w-full items-center justify-between rounded-xl border border-zinc-800 bg-zinc-900/65 px-3 py-3.5 text-left text-[15px] font-medium text-zinc-100 transition hover:border-zinc-700 hover:bg-zinc-800/70"
                                onClick={() => {
                                    logout();
                                    setIsOpen(false);
                                }}
                            >
                                <span className={labelWithIconClass}>
                                    <span className={iconWrapClass}>
                                        <CiLogout className="text-lg" />
                                    </span>
                                    Cerrar Sesión
                                </span>
                                <LuChevronRight className={chevronClass} />
                            </button>
                        </div>
                    )}

                    <div className="relative mt-3 px-1">
                        <p className="text-[11px] text-zinc-500">
                            Descubrí eventos y gestioná tu cuenta desde acá.
                        </p>
                    </div>
                </div>
            </div>
        );
    }
);

MobileMenu.displayName = "MobileMenu";

export default MobileMenu;
